import type { CustomerEntityWithRelationship } from '@/types/generated'

/**
 * Build the entity list to store after a case-entities API response.
 *
 * When not appending, always returns the fetched results so nested fields
 * (e.g. proposed_changes, field values) stay in sync even when relationship
 * UUIDs are unchanged.
 *
 * :param currentEntities: Entities currently held in the case store
 * :param fetchedResults: Results from the case-entities endpoint
 * :param append: Whether this fetch is paginating forward
 *
 * :return: The entity list to assign to case store state
 */
export function mergeCaseEntityResults(
  currentEntities: CustomerEntityWithRelationship[],
  fetchedResults: CustomerEntityWithRelationship[],
  append: boolean
): CustomerEntityWithRelationship[] {
  if (append) {
    return [...currentEntities, ...fetchedResults]
  }
  return fetchedResults
}
